var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDownloadPdfWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 166.35001,
    width: 166.35001,
    viewBox: "0 0 166.35 166.35001",
    "data-name": "Capa 1",
    id: "Capa_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#c72e26;}.cls-2,.cls-4{fill:#fff;}.cls-3{fill:#737373;}.cls-4{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:0.25px;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-378.795,-273.02501)",
    "data-name": "Descarga",
    id: "Descarga-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Descarga-2",
    id: "Descarga-2-3"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      stroke: "#1d1d1b",
      strokeWidth: "0.25px",
      strokeMiterlimit: 10
    },
    r: 83.050003,
    cy: 356.20001,
    cx: 461.97,
    className: "cls-4",
    "data-name": "Elipse 6-2",
    id: "Elipse_6-2-2"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 125",
    id: "Grupo_125-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "m 473.61,309.87 c 3.89,3.89 5.27,14.22 4.55,19.08 a 29.62,29.62 0 0 1 20.37,3.93 104.7,104.7 0 0 0 -24.92,-23.01 z m -18.53,40.36 c -0.3,-0.66 -1.17,-0.76 -1.94,-0.76 h -1.84 v 3.11 h 1.84 c 0.77,0 1.64,-0.1 1.94,-0.76 a 1.75,1.75 0 0 0 0,-1.59 z",
    className: "cls-3",
    "data-name": "file-33",
    id: "file-33-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "m 470.92,336.36 c 0,0 5.05,-26.75 -11.2,-26.75 h -28.16 v 80.32 h 32.72 a 11.47,11.47 0 0 1 -0.08,-1.76 19.56,19.56 0 0 1 34.3,-13 V 346.45 C 498.52,335 480.92,333.92 470.92,336.36 Z m -13,16.15 a 2.92,2.92 0 0 1 -1.17,1.59 4.73,4.73 0 0 1 -3,0.93 h -2.52 v 4.28 h -3 V 347 h 5.55 a 3.93,3.93 0 0 1 4.12,2.52 4.39,4.39 0 0 1 0.1,2.99 z m 12.36,3.7 a 3.3,3.3 0 0 1 -0.75,1.34 6.53,6.53 0 0 1 -1.68,1.27 6,6 0 0 1 -2.53,0.5 H 460 V 347 h 5.38 a 5.46,5.46 0 0 1 4,1.52 7.15,7.15 0 0 1 0.94,7.69 z m 11.44,-6.56 H 476 V 352 h 5 v 2.44 h -5 v 4.88 h -3 V 347 h 8.74 z",
    className: "cls-3",
    "data-name": "Trazado 372",
    id: "Trazado_372-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "m 468,353.68 a 2.91,2.91 0 0 1 -0.25,1.27 2.62,2.62 0 0 1 -0.93,1.34 h -0.08 a 2.89,2.89 0 0 1 -1.51,0.42 h -2.1 v -7.06 h 1.59 a 2.82,2.82 0 0 1 3.12,2.1 13.83,13.83 0 0 1 0.16,1.93 z",
    className: "cls-3",
    "data-name": "Trazado 373",
    id: "Trazado_373-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "m 494.28,385.13 -4.2,4.81 -6.29,7.22 -6.29,-7.22 -4.26,-4.81 h 6.09 v -15 h 9 v 15 z",
    className: "cls-3",
    "data-name": "Trazado 374",
    id: "Trazado_374-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "m 501.85,388.15 a 18.022486,18.022486 0 0 1 -36,1.8 10.87,10.87 0 0 1 -0.1,-1.8 18,18 0 0 1 8.65,-15.47 l 1.89,2.45 a 15,15 0 0 0 -7.52,13 5.28,5.28 0 0 0 0.2,1.81 14.87,14.87 0 0 0 14.81,13.2 15,15 0 0 0 15,-15 16,16 0 0 0 -0.31,-3 15.09,15.09 0 0 0 -7.16,-10 l 1.74,-2.45 a 18.11,18.11 0 0 1 5.41,5.05 17.78,17.78 0 0 1 3.39,10.41 z",
    className: "cls-3",
    "data-name": "Trazado 375",
    id: "Trazado_375-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownloadPdfWhiteIcon);
export default __webpack_public_path__ + "static/media/circle-download-pdf-white-icon.4b68333967429dbd19a097b966e11605.svg";
export { ForwardRef as ReactComponent };